import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// Components
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { SelectBoxComponent } from './select-box/select-box.component';
import { CheckBoxComponent } from './check-box/check-box.component';
import { TextBoxComponent } from './text-box/text-box.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
// Module of components
import { TextViewComponent } from './text-view/text-view.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GroupFieldsComponent } from './group-fields/group-fields.component';
import { TextViewAreaComponent } from './text-view-area/text-view-area.component';
import { DmsImageComponent } from './dms-image/dms-image.component';
import { TextViewBpComponent } from './text-view-betriebspunkt/text-view-bp.component';
import { EmptyBoxComponent } from './empty-box/empty-box.component';
import { FieldDividerComponent } from './field-divider/field-divider.component';
import { FullDividerComponent } from './full-divider/full-divider.component';
import {ErrorTooltipComponent} from "./error-tooltip/error-tooltip.component";
import {BootstrapValidationCssDirective} from "./directives/bootstrap-validation-css.directive";
import {CommonModule} from "@angular/common";
import {
  AccordionFormSectionComponent
} from "./accordion-form-section/accordion-form-section.component";

export const Form_Controls_COMPONENTS = [
  RadioButtonComponent,
  SelectBoxComponent,
  CheckBoxComponent,
  TextBoxComponent,
  DatePickerComponent,
  TextViewComponent,
  GroupFieldsComponent,
  FieldDividerComponent,
  FullDividerComponent,
  TextViewAreaComponent,
  EmptyBoxComponent,
  DmsImageComponent,
  TextViewBpComponent,
  ErrorTooltipComponent,
  BootstrapValidationCssDirective,
  AccordionFormSectionComponent
];

@NgModule({
  declarations: Form_Controls_COMPONENTS,
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    SharedModule,
  ],
  exports: Form_Controls_COMPONENTS,
})
export class FormControlsModule {}
